import React from 'react';
import { PriceTagIcon } from '../../Icons';

interface NegotiablePriceBadgeProps {
  className?: string;
  variant?: 'header' | 'chip';
}

export const NegotiablePriceBadge: React.FC<NegotiablePriceBadgeProps> = ({
  className = '',
  variant = 'header',
}) => {
  if (variant === 'chip') {
    return (
      <span
        id="negotiable-price-badge-chip"
        className={`inline-flex items-center gap-1.5 px-3 py-1 rounded-lg text-xs font-black uppercase tracking-wider bg-emerald-50 text-emerald-700 border border-emerald-200 shadow-xs ${className}`}
      >
        <PriceTagIcon className="w-3.5 h-3.5 text-emerald-600" />
        <span>Precio Negociable</span>
      </span>
    );
  }

  return (
    <div
      id="negotiable-price-badge"
      className={`inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-xs font-bold tracking-wide bg-emerald-500/20 text-emerald-100 border border-emerald-400/30 backdrop-blur-xs shadow-xs ${className}`}
      title="El precio de este inmueble es negociable"
    >
      <span className="w-2 h-2 rounded-full bg-emerald-400 animate-pulse shrink-0" />
      <PriceTagIcon className="w-3.5 h-3.5 text-emerald-300 shrink-0" />
      <span className="uppercase font-extrabold text-[11px] tracking-wider whitespace-nowrap">
        Precio Negociable
      </span>
    </div>
  );
};
